var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "whatsapp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "BG_164",
    "data-name": "BG 164",
    d: "M0,0H35V35H0Z",
    fill: "none",
    opacity: 0.58
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.146,13.724a14.588,14.588,0,1,0-27.2,8.152L.651,26.7a1.453,1.453,0,0,0,1.794,1.779L7.2,27.169a14.516,14.516,0,0,0,7.379,2A14.808,14.808,0,0,0,29.146,13.724Zm-7.437,6.285a3.48,3.48,0,0,1-.5.744,3.324,3.324,0,0,1-1.2.86,3.568,3.568,0,0,1-1.429.277,5.94,5.94,0,0,1-2.377-.54A13.357,13.357,0,0,1,13.7,19.907a21.073,21.073,0,0,1-2.392-2.042,20.856,20.856,0,0,1-2.042-2.392A12.829,12.829,0,0,1,7.84,12.98a6.175,6.175,0,0,1-.525-2.392,3.81,3.81,0,0,1,.262-1.415,3.256,3.256,0,0,1,.846-1.225A2.107,2.107,0,0,1,9.94,7.263a1.426,1.426,0,0,1,.6.131,1.208,1.208,0,0,1,.5.408l1.692,2.392a2.354,2.354,0,0,1,.292.51,1.065,1.065,0,0,1,.1.452,1.046,1.046,0,0,1-.16.525,2.566,2.566,0,0,1-.408.525L12,12.79a.374.374,0,0,0-.117.292.732.732,0,0,0,.029.175,1.007,1.007,0,0,1,.058.146,5.846,5.846,0,0,0,.685.933c.335.379.685.773,1.065,1.152s.773.744,1.167,1.079a5.6,5.6,0,0,0,.948.671c.044.015.088.044.131.058a.478.478,0,0,0,.5-.1l.554-.554a2.343,2.343,0,0,1,.525-.408,1,1,0,0,1,.525-.16,1.065,1.065,0,0,1,.452.1,2.654,2.654,0,0,1,.51.292l2.421,1.721a1.231,1.231,0,0,1,.408.467,1.525,1.525,0,0,1,.117.569C21.884,19.469,21.826,19.746,21.709,20.009Z",
    transform: "translate(2.908 2.916)",
    fill: "#25d366"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H35V35H0Z",
    fill: "none",
    opacity: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp2);
export default __webpack_public_path__ + "static/media/whatsapp2.39ec3e8a46b1a57ef793bae6f376e71a.svg";
export { ForwardRef as ReactComponent };